export default {
    methods: {
        validateParsleyForm(formId) {
            let form = $(`#${formId}`).parsley();
            form.reset();
            form.validate();

            return form.isValid();
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/parsley.js